import script from "./ResultsInfoWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsInfoWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./ResultsInfoWrapper.vue?vue&type=style&index=0&id=61e599aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e599aa"]])

export default __exports__